import type { HTMLAttributes, ReactElement } from 'react';

import { classNames } from '@m1work/shared-utils';

import styles from './BorderCard.module.scss';

export interface BorderCardProps extends HTMLAttributes<HTMLDivElement> {
    /** Small padding (8–16px instead of 16–40px). @default false */
    minimal?: boolean;
}

/**
 * A block outlined with a soft border, with padding that grows with the screen. `minimal` makes the padding small.
 *
 * @example
 * <BorderCard minimal>{summary}</BorderCard>
 */
export function BorderCard({ className, children, minimal = false, ...props }: BorderCardProps): ReactElement {
    return (
        <div className={classNames(styles['border-card'], minimal && styles.minimal, className)} {...props}>
            {children}
        </div>
    );
}
